import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

export default function Navbar({ stats }) {
  const loc = useLocation();
  const isViewer = loc.pathname === '/';

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <Link to="/" className={styles.logo}>
          <div className={styles.logoIcon}>🔍</div>
          <span className={styles.logoText}>HARScope</span>
          <span className={styles.logoBadge}>Pentester</span>
        </Link>
        <nav className={styles.nav}>
          <Link to="/" className={`${styles.navLink} ${loc.pathname === '/' ? styles.active : ''}`}>Viewer</Link>
          <Link to="/about" className={`${styles.navLink} ${loc.pathname === '/about' ? styles.active : ''}`}>About</Link>
          <Link to="/contact" className={`${styles.navLink} ${loc.pathname === '/contact' ? styles.active : ''}`}>Contact</Link>
        </nav>
      </div>

      {isViewer && stats && (
        <div className={styles.stats}>
          <div className={styles.stat}>
            <div className={styles.statVal}>{stats.total}</div>
            <div className={styles.statLbl}>Requests</div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statVal}>{stats.size}</div>
            <div className={styles.statLbl}>Total Size</div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statVal}>{stats.time}</div>
            <div className={styles.statLbl}>Load Time</div>
          </div>
          <div className={styles.stat}>
            <div className={`${styles.statVal} ${styles.statErr}`}>{stats.errors}</div>
            <div className={styles.statLbl}>Errors</div>
          </div>
        </div>
      )}
    </header>
  );
}
